function About() {
  return (
    <section className="about section" id="about">
      <div className="aboutImg">
        <img
          src="https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=900&q=80"
          alt="Classroom"
        />
      </div>

      <div className="aboutText">
        <p className="sectionTag">About Us</p>
        <h2>Guided by Prof. Amarjeet Gupta</h2>
        <h3>C.A.-Final|C.S.|M.Com|NET|LLB</h3>
        <br></br>
        <p>
          At Orion Academy, we believe every student can succeed with the right guidance.
          Our focus is on strong concepts, regular practice, student-friendly teaching,
          and personal attention.
        </p>
      </div>
    </section>
  );
}

export default About;
